export default "__VITE_ASSET__Y4USlN89__"